var _circle, _rect, _rect2, _rect3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrafanaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 89,
    viewBox: "0 0 89 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 44.0131,
    cy: 44.0131,
    r: 44.0131,
    fill: "url(#paint0_linear_655_3888)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 45.7144,
    width: 10.8571,
    height: 16.2857,
    rx: 2,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52.1431,
    y: 34.8572,
    width: 10.8571,
    height: 27.1429,
    rx: 2,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5713,
    y: 24,
    width: 10.8571,
    height: 38,
    rx: 2,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_3888",
    x1: 44.0131,
    y1: -101.675,
    x2: 44.0131,
    y2: 88.0263,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BA4A9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1142E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrafanaIcon);
export default __webpack_public_path__ + "static/media/grafanaIcon.75dcb5001c16efb5779ed3b5f2c7dd27.svg";
export { ForwardRef as ReactComponent };